import styled from 'styled-components';

export const TechnologyColumnContainer = styled.div``;
